import { hostApi } from "@/apis/index";
import Vue from 'vue';

const api_sc = `${hostApi}/api/app/scs`;

function getSc(id) {
    return Vue.prototype.$http.get(`${api_sc}/${id}`);
}

function getScList(params) {
    return Vue.prototype.$http.get(api_sc, { params });
}

function getScListRecommend(params) {
    return Vue.prototype.$http.get(`${api_sc}/recommend`, { params });
}


export {
    getSc,
    getScList,
    getScListRecommend,
};
